// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__12GzE","title":"Info_title__JDgRH","links":"Info_links__FNbA-","link":"Info_link__2xnmV","logo":"Info_logo__1xaEc"};